import React, {useState} from 'react';
import styles from './QuestsGuide.module.css';
import {QuestData} from './model';
import icUp from "../assets/icon/ic_chevron_up.svg";
import icDown from "../assets/icon/ic_chevron_down.svg";
import {useCollapse} from "react-collapsed";
import icVideo from "../assets/icon/ic_video.svg";
import icImportant from "../assets/icon/ic_important.svg";
import icRecommend from "../assets/icon/ic_recommend.svg";
import ModalVideo from "react-modal-video";
import "react-modal-video/css/modal-video.min.css";
import {useTranslation, Trans} from "react-i18next";

interface QuestCardProps {
    quest: QuestData;
}

const QuestCard: React.FC<QuestCardProps> = ({quest}) => {
    const {t} = useTranslation();
    const [isExpanded, setIsExpanded] = useState<boolean>(true);
    const {getToggleProps, getCollapseProps} = useCollapse({
        isExpanded
    });
    const [myMap, setMyMap] = useState<Map<string, boolean>>(new Map());
    const updateMap = (k: string, v: boolean) => {
        setMyMap(new Map(myMap.set(k, v)));
    }

    function decideLink(description?: string) {
        switch (description) {
            case 'quest_1_option_1_desc':
                return 'https://scan.test.btcs.network/faucet';
            case 'quest_1_option_2_desc':
                return 'https://www.bnbchain.org/en/testnet-faucet';
            case 'quest_1_option_3_desc':
                return 'https://faucet.quicknode.com/mantle';
            case 'quest_2_option_1_desc':
                return 'https://test.pell.network/faucet';
            case 'quest_3_option_1_desc':
                return 'https://test.pell.network/restake';
            case 'quest_4_option_1_desc':
                return 'https://test.pell.network/operator';
        }
    }

    return (
        <div>

            <button
                {...getToggleProps({
                    onClick: () => setIsExpanded(!isExpanded),
                })}
                className={styles.questDashboard}>
                <div className={styles.questInfo}>
                    <span className={styles.questTitle}>{t('quest')} {quest.number}</span>
                    <span className={styles.questDescription}>{quest.title}</span>
                </div>
                <div className={styles.questIcon}>
                    <img src={isExpanded ? icUp : icDown} alt="" className={styles.icon}/>
                </div>
            </button>

            <section className={styles.optionsContainer} {...getCollapseProps()}>
                {quest.number === 1 && (
                    <>
                        <div className={styles.claimCardContentCustom}>
                            <div style={{display: 'flex', justifyContent: 'center'}}>{t('favorite')}
                                <img className={styles.icRecommendIcon} src={icRecommend}/>
                                <span className={styles.recommendedText}>{t('recommended')}</span></div>
                        </div>
                    </>
                )}
                {quest.options ? (
                    quest.options.map((option, index) => (
                        <div key={index} className={styles.claimCard}>
                            <div className={styles.claimCardContent}>
                                {quest.number === 1 && (
                                    <div className={styles.stepNumber}>{index + 1}</div>)}

                                {option.title && (
                                    <span className={styles.font20}>{option.title}</span>)}
                                {option.description && (
                                    <span className={styles.font16}>
                                        <Trans i18nKey={option.description}
                                               components={{
                                                   alink: <a href={decideLink(option.descriptionKey)}
                                                                  target="_blank" style={{color: '#DD5800'}}></a>
                                               }}/>
                                    </span>)}

                                {(option.videoLinks?.length ?? 0) > 1 && (
                                    <span className={styles.font16}>{t('videoGuideHere')}</span>
                                )}

                                <div>
                                    {option.videoLinks?.map(item => (
                                        <div className={styles.videoGuideLink}
                                             onClick={() => updateMap(quest.number.toString() + option.number.toString() + item.number.toString(), true)}>
                                            <p className={styles.stepDescription}>{item.title ?? t('videoGuide')}</p>
                                            <img className={styles.icVideo} src={icVideo}/>
                                        </div>
                                    ))}
                                </div>
                                {option.videoLinks?.map(item => (
                                    <ModalVideo
                                        channel="custom"
                                        isOpen={myMap.get(quest.number.toString() + option.number.toString() + item.number.toString())}
                                        url={item.url ?? ''}
                                        onClose={() => updateMap(quest.number.toString() + option.number.toString() + item.number.toString(), false)}
                                    />
                                ))}

                            </div>
                            <button className={styles.appButton} onClick={() => {
                                option.buttonLink && window.open(option.buttonLink, '_blank');
                            }}>
                                <span className={styles.appButtonText}>{option.buttonText}</span>
                            </button>
                        </div>
                    ))
                ) : null}
                {quest.importantNote && (
                    <aside className={styles.importantNote}>
                        <div className={styles.importantNoteHeader}>
                            <img
                                src={icImportant}
                                alt="" className={styles.importantNoteIcon}/>
                            <span>{t('important')}</span>
                        </div>
                        <p className={styles.importantNoteText}>
                            {quest.importantNote}
                        </p>
                    </aside>
                )}

            </section>
        </div>
    );
};

export default QuestCard;